export function parseCode (){
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  var charsto = 'vSoajc7dRzpWifGyNxZnV5k+DHLYhJ46lt0U3QrgEuq8sw/XMeBAT2Fb9P1OIKmC'

  var encode = function(input) {
    var tempVal = window.btoa(input)
    var code = ''
    tempVal = tempVal.split('')
    tempVal.map(function(val) {
      if (chars.indexOf(val) != -1) {
        code += charsto.split('')[chars.indexOf(val)]
      } else {
        code += val
      }
    })
    return code
  }

  var decode = function(input) {
    var tempVal = input
    var code = ''
    tempVal = tempVal.split('')
    tempVal.map(function(val) {
      if (charsto.indexOf(val) != -1) {
        code += chars.split('')[charsto.indexOf(val)]
      } else {
        code += val
      }
    })
    try {
      return window.atob(code)
    } catch (e) {
      return ''
    }
  }

  return {
    encode64: encode,
    decode64: decode
  }
}

export function isURL (str){
  return !!str.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi)
}

export function pos_fun (src){
  var win = window;
  var n = (+new Date()) + '.r' + Math.floor(Math.random() * 1000);
  var img = win[n] = new Image();
  img.onload = img.onerror = function() {
      win[n] = null;
  };
  img.src = src;
}

export function device() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/.+Mac OS X/); //ios终端
  return {
    isAndroid: isAndroid,
    isiOS: isiOS
  }
}

export function sendAdtracking (url){
  if(device().isiOS) return;
  if(!url) return;
  url = parseCode().decode64(url)
  if(isURL(url)){
    pos_fun(url)
  }
}

export function interceptADLogoAppidSuccess(){
  let appIdList = ["111627","113403","115345","117331","113418","119090","119089"]
  let data = JSON.parse($('body').data('data'))
  if(data && data.device){
    let appId = data.device.appId
    if(appIdList.indexOf(appId) > -1){
      return true
    }
  }
  return false
}

export function addADLogo () {
  if(!interceptADLogoAppidSuccess()) return;
  let icon = 'https://hybird.rayjump.com/static/icon-mtg.png';
  let text = navigator.language.indexOf('zh') > -1 ? '广告' : 'AD';
  let warStyle = 'position:fixed;z-index:99999;height:20px;line-height:20px;color:#fff;font-size:0;top:0;left:10px;'
  let imgStyle = 'width:16px'
  let spanStyle = 'font-size: 12px;display: block;float: right;color:#aaa;margin-left:5px;'
  // if(device().isAndroid){
  //   spanStyle += 'margin: 3px 0 0 0;'
  // }
  
  let dom = `
    <div style="${warStyle}">
      <img src="${icon}" style="${imgStyle}">
      <span style="${spanStyle}">${text}</span>  
    </div>
  `
  let div = document.createElement('div')
  div.innerHTML = dom
  document.body.appendChild(div)
}

// 判断是否是appflyer
export function getAppFlyerRoute(res) {
  var arr = [res.click_url, res.notice_url]
  if(res.ad_tracking && res.ad_tracking.click){
    arr = arr.concat(res.ad_tracking.click)
  }

  var isAppFlyer = arr.some(function(item){
    return item.indexOf('[af_token]') > -1
  })
  if(!isAppFlyer) return;

  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "https://fvalid.appsflyer.com/mintegral/cp.sdk.1.2.6.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'AppsFlyer-jssdk'));

  window.onAFReady = function (AF) {
    window.AF_SDK = AF
    document.body.addEventListener("touchstart", function (e) {
      window.AFEVENT = e
    });
  };  
}

// 替换所有clickurl中的appflyerhost
export function replaceAppFlyerHost(res){
  var token = window.AF_SDK && window.AFEVENT && window.AF_SDK.getToken(window.AFEVENT)

  if(!token) return;

  function replaceElement(ele) {
    return ele.replace('[af_token]',token)
  }

  res.click_url = replaceElement(res.click_url);
  res.notice_url = replaceElement(res.notice_url);
  res.ad_tracking && res.ad_tracking.click && (res.ad_tracking.click = res.ad_tracking.click.map(function(item){ return replaceElement(item)}))

}


// WEBPACK FOOTER //
// ./src/rv/splash/lib/public.js